module.exports = __webpack_public_path__ + "img/label-Ct.c8089355.png";